<div class="container">
  <mat-card [class]="type">
    <mat-card-title-group>
      <mat-card-title class="mat-subheading-2 title">{{ title }}</mat-card-title>
      @if (subtitle) {
        <mat-card-subtitle class="mat-subheading-1"> {{ subtitle }}</mat-card-subtitle>
      }
    </mat-card-title-group>
    <mat-card-content class="mat-body-2 text">
      {{ text }}
    </mat-card-content>
  </mat-card>
</div>
